if (!customElements.get('membership-features')) {
  class MembershipFeatures extends HTMLElement {
    constructor() {
      super();
      this.items = [];
      this.activeItem = null;
    }

    connectedCallback() {
      this.items = this.querySelectorAll('[data-accordion-item]');
      this.bindEvents();
      this.openFirst();
    }

    bindEvents() {
      this.items.forEach((item) => {
        const header = item.querySelector('[data-accordion-header]');
        if (header) {
          header.addEventListener('click', () => this.toggle(item));
        }
      });
    }

    openFirst() {
      const firstItem = this.items[0];
      if (firstItem) {
        this.open(firstItem);
      }
    }

    toggle(clickedItem) {
      const isActive = clickedItem.classList.contains('is-active');

      this.closeAll();

      if (!isActive) {
        this.open(clickedItem);
      }
    }

    open(item) {
      const body = item.querySelector('[data-accordion-body]');
      const header = item.querySelector('[data-accordion-header]');

      item.classList.add('is-active');
      body.style.maxHeight = body.scrollHeight + 'px';
      header.setAttribute('aria-expanded', 'true');
      this.activeItem = item;
    }

    close(item) {
      const body = item.querySelector('[data-accordion-body]');
      const header = item.querySelector('[data-accordion-header]');

      item.classList.remove('is-active');
      body.style.maxHeight = null;
      header.setAttribute('aria-expanded', 'false');
    }

    closeAll() {
      this.items.forEach((item) => this.close(item));
      this.activeItem = null;
    }

    disconnectedCallback() {
      this.items = [];
      this.activeItem = null;
    }
  }

  customElements.define('membership-features', MembershipFeatures);
}
